import { render, staticRenderFns } from "./OaBusinessFields.vue?vue&type=template&id=f159a092&scoped=true"
import script from "./OaBusinessFields.vue?vue&type=script&lang=js"
export * from "./OaBusinessFields.vue?vue&type=script&lang=js"
import style0 from "./OaBusinessFields.vue?vue&type=style&index=0&id=f159a092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f159a092",
  null
  
)

export default component.exports